import { isDefined } from '@eigtech/function-utils'
import {
  ArrayFieldRemoveButton,
  useArrayFieldRemoveButtonProps,
} from '@eigtech/ui-shared-forms/shadcn'
import { ButtonProps } from '@eigtech/ui/components/button'
import { HStack } from '@eigtech/ui/components/stack'
import {
  ContactFormCommunicationInformationFields,
  useContactFormArrayFieldRowContext,
  useContactFormContext,
} from './ContactFormSchema/ContactFormSchema'

export type ContactInfoRowContainerProps = {
  children: React.ReactNode
} & RemoveContactInfoButtonProps

export function ContactInfoRowContainer({
  children,
  ...buttonProps
}: ContactInfoRowContainerProps) {
  const { id } = useContactFormArrayFieldRowContext()

  return (
    <HStack className="items-start" id={id}>
      {children}
      <div className="pt-7.5">
        <RemoveContactInfoButton {...buttonProps} />
      </div>
    </HStack>
  )
}

type RemoveContactInfoButtonProps = {
  index: number
  indexKey?: keyof ContactFormCommunicationInformationFields
} & ButtonProps

function RemoveContactInfoButton({
  index,
  indexKey,
  disabled: isDisabledOverride,
  ...props
}: RemoveContactInfoButtonProps) {
  const { onClick, isDisabled: isDisabledDefault } = useArrayFieldRemoveButtonProps()

  const isDisabled = isDisabledOverride ?? isDisabledDefault

  const { setValue, getValues } = useContactFormContext()

  function handleRemove() {
    if (indexKey !== undefined) {
      const value = getValues()[indexKey]

      if (isDefined(value) && value >= index) {
        setValue(indexKey, value === index ? null : value - 1)
      }
    }

    onClick()
  }

  return <ArrayFieldRemoveButton {...props} disabled={isDisabled} onClick={handleRemove} />
}
